export const calcPagination = ({ current_page = 0, total_pages = 100 }) => ({ current_page, next_page: current_page + 1, isLastPage: current_page >= total_pages });
